import { useTranslation } from "react-i18next";

import InputText from "./Inputs/InputText";
import InputDate from "./Inputs/InputDate";
import InputSelect from "./Inputs/InputSelect";
import InputLevels from "./Inputs/InputLevels";
import InputStatus from "./Inputs/InputStatus";
import InputLingoPlans from "./Inputs/InputPlans";
import InputProfiles from "./Inputs/InputProfiles";
import InputTicketTypes from "./Inputs/InputTicketTypes";
import InputTicketStatus from "./Inputs/InputTicketStatus";
import InputTicketProfiles from "./Inputs/InputTicketProfiles";
import InputTicketSubTypes from "./Inputs/InputTicketSubTypes";
import InputLingoLanguages from "./Inputs/InputLingoLanguages";

const Filter = ({
  filters,
  inputChange,
  clear,
  submit,
  loading,
  expandFilter,
  expand,
  resetCycle = false,
  resetCycleClick,
}) => {
  const { t } = useTranslation();

  return (
    <div className="bigBox bigBoxFilter">
      <h2>
        <i className="fa fa-filter" aria-hidden="true"></i>
        {t("FILTERS")}
      </h2>
      <form>
        {filters.map((data, index) => {
          switch (data.type) {
            case "text":
              return <InputText key={index} {...data} onChange={inputChange} />;
            case "select":
              return <InputSelect key={index} {...data} onChange={inputChange} />;
            case "date":
              return <InputDate key={index} {...data} onChange={inputChange} />;
            case "lingoLanguages":
              return <InputLingoLanguages key={index} {...data} onChange={inputChange} />;
            case "levels":
              return <InputLevels key={index} {...data} onChange={inputChange} />;
            case "status":
              return <InputStatus key={index} {...data} onChange={inputChange} />;
            case "ticketStatus":
              return <InputTicketStatus key={index} {...data} onChange={inputChange} />;
            case "profiles":
              return <InputProfiles key={data.name} {...data} onChange={inputChange} />;
            case "ticketProfiles":
              return <InputTicketProfiles key={data.name} {...data} onChange={inputChange} />;
            case "ticketTypes":
              return <InputTicketTypes key={data.name} {...data} onChange={inputChange} />;
            case "ticketSubTypes":
              return <InputTicketSubTypes key={data.name} {...data} onChange={inputChange} />;
            case "lingoPlans":
              return <InputLingoPlans key={data.name} {...data} onChange={inputChange} />;
            default:
              break;
          }
        })}
      </form>
      <div className="buttons">
        {resetCycle && (
          <button
            className="clear"
            onClick={resetCycleClick}
            style={{ display: "flex", alignItems: "center", gap: 10 }}
          >
            <i className="fa fa-refresh" aria-hidden="true" />
            {t("UPDATE_SCREEN")}
          </button>
        )}
        {expandFilter && (
          <button className="clear" onClick={(e) => expand(e)}>
            {t("VIEW_MORE")}
          </button>
        )}
        <button className="clear" onClick={(e) => clear(e)}>
          {t("CLEAR_FILTERS")}
        </button>
        <button onClick={(e) => submit(e)} disabled={loading}>
          {t("FILTER")}
        </button>
      </div>
    </div>
  );
};

export default Filter;
